module.exports = __webpack_public_path__ + "img/loginBG2b.1c915da8.png";